import { DDSB } from "./ddsb";
import { Z } from "./query";

const VideoRequiredPixelThreshold = 130000;

/*
const acceptablePanelSizes = {
    3: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    4: [3, 6, 9, 12, 15, 18, 21, 24],
    6: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    7: [3, 6, 9, 12, 15, 18, 21, 24],
    8: [3, 6, 9, 12, 15, 18, 21, 24],
    9: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    11: [3, 6, 9, 12, 15, 18, 21, 24],
    12: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    15: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    16: [3, 6, 9, 12, 15, 18, 21, 24],
    18: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    19: [3, 6, 9, 12, 15, 18, 21, 24],
    20: [3, 6, 9, 12, 15, 18, 21, 24],
    21: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
    23: [3, 6, 9, 12, 15, 18, 21, 24],
    24: [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24],
};
const panelOpts = [3, 4, 6, 7, 8, 9, 11, 12, 15, 16, 18, 19, 20, 21, 23, 24,];
*/
//let panelOpts = Object.keys(acceptablePanelSizes).map(p => parseInt(`${p}`));

// set A: any integer divisible by 3
// set C: any integer divisible by 4
// set D: any integer divisible by 4 and +3
// set B: union of A, C and D
// axis [A] and axis [A] - possible
// axis [A] and axis [B] - possible
// axis [B] and axis [B] - impossible
const UpperAxisLimit: number = 100;
export class AcceptablePanelSizes {

    static UpperAxisLimit = UpperAxisLimit;

    static isAcceptableSelection(x: number, y: number) {
        if (AcceptablePanelSizes.belongsToSetA(x) && AcceptablePanelSizes.belongsToSetA(y)) return true;
        if (AcceptablePanelSizes.belongsToSetA(x) && AcceptablePanelSizes.belongsToSetB(y)) return true;
        if (AcceptablePanelSizes.belongsToSetA(y) && AcceptablePanelSizes.belongsToSetB(x)) return true;
        return false;
    }

    static belongsToSetA(int: number) {
        if (int <= 0) return false;
        if (Math.round(int / 3) == (int / 3)) return true;
        return false;
    }

    static belongsToSetC(int: number) {
        if (int <= 0) return false;
        if (Math.round(int / 4) == (int / 4)) return true;
        return false;
    }

    static belongsToSetD(int: number) {
        if (int <= 0) return false;
        return AcceptablePanelSizes.belongsToSetC(int - 3);
    }

    static belongsToSetB(int: number) {
        return AcceptablePanelSizes.belongsToSetA(int) || AcceptablePanelSizes.belongsToSetC(int) || AcceptablePanelSizes.belongsToSetD(int);
    }

    static setA(max: number = UpperAxisLimit) {
        let set = [];
        for (let i = 1; i < max; i++) {
            if (AcceptablePanelSizes.belongsToSetA(i)) set.push(i);
        }
        return set;
    }
    static setB(max: number = UpperAxisLimit) {
        let set = [];
        for (let i = 1; i < max; i++) {
            if (AcceptablePanelSizes.belongsToSetB(i)) set.push(i);
        }
        return set;
    }

    static get panelOpts() { // backwards compatibility kludge
        return AcceptablePanelSizes.setB(UpperAxisLimit);
    }

    static get acceptablePanelGrid(): Record<number, number[]> {
        let dict = {};

        for (let i = 1; i < UpperAxisLimit; i++) {
            if (AcceptablePanelSizes.belongsToSetB(i)) {
                let row = [];
                for (let j = 1; j < UpperAxisLimit; j++) {
                    if (AcceptablePanelSizes.isAcceptableSelection(i, j)) {
                        row.push(j);
                    }
                }
                dict[i] = row;
            }
        }

        return dict;
    }
}

let app: DDSB;
export class QuoteBuilder {
    get panelSizes() {
        return AcceptablePanelSizes;
    }

    logPanelSizes() {
        let axes = AcceptablePanelSizes.acceptablePanelGrid;
        let sizes = '';
        Object.keys(axes).forEach(ix => {
            sizes += (`${ix}: [${axes[ix].join(', ')}]`) + '\n';
        });
        console.log(sizes);
        return sizes;
    }

    static instance: QuoteBuilder;
    static init(ddsb: DDSB) {
        let form = Z.first<HTMLFormElement>('form#quote-designer-form');
        if (!form) return null;
        app = ddsb;

        QuoteBuilder.instance = new QuoteBuilder(form);
        return QuoteBuilder.instance;
    }

    form: HTMLFormElement;
    get appContainer() {
        return Z.firstFrom(this.form, '#quote-designer-gui');
    }
    get guiType() {
        return this.appContainer.dataset.gui;
    }

    constructor(form: HTMLFormElement) {
        this.form = form;

        this.formData.forEach((value, key) => {
            this.lastData[key] = `${value}`;
        });

        Z.bindLiveGui(ev => this.updateGui());

        console.log(`Initialised Quote Builder`);

        let redirmaybe = true;

        try {
            let params = new URLSearchParams(window.location.search);
            if (params.has('customise')) {
                Z.forFirst(`button[data-quote-pathway-action="customise-selection"]`, btn => btn.click());
                redirmaybe = false;
            }
        } catch (err) { }

        let phase = Z.valueOf('#GuiPhase');
        if (redirmaybe) {
            let btn = Z.one(`button[data-quote-pathway-action="${phase}"]`);
            if (btn) {
                btn.click();
            }
        }
    }

    get quotePathwayPages() {
        return Z.select('article.quote-application-pathway > section[data-quote-pathway-action]');
    }
    get activeQuotePathwayPage() {
        return this.quotePathwayPages.find(el => el.classList.contains('active'));
    }

    quotePathwayAction(action: string, button: HTMLElement) {
        console.log(`Quote pathway action: ${action}`);
        this.quotePathwayPages.forEach(e => {
            e.classList.remove('active');
            if (e.dataset.quotePathwayAction == action) {
                e.classList.add('active');
            }
        });

        let isQuickQuote = false;
        if (action == 'customise-selection') {
            isQuickQuote = false;
        } else if (action == 'quote-now') {
            if (button.classList.contains('quick-quote-button')) {
                isQuickQuote = true;
            }
        }

        Z.setValue('#QuickQuoteSelection', isQuickQuote ? 'true' : 'false', true);

        Z.setValue('#GuiPhase', action);
        fetch(`/quote/updatephase/${this.id}/${action}`);
    }

    get id() { return this.appContainer.dataset.id; }

    get signWidthRow() { return Z.one('#sign-width-row'); }
    get signHeightRow() { return Z.one('#sign-height-row'); }

    get constructionTypeRow() { return Z.one('#construction-type-row'); }
    get constructionType() { return Z.valueOf('#ConstructionType', 'Steel'); }
    get constructionTypeSelect() { return Z.one<HTMLSelectElement>('#ConstructionType'); }

    get signSidednessToggle() { return Z.one<HTMLInputElement>('#DoubleSidedSign'); }
    get doubleSidedSign() { return this.signSidednessToggle?.checked ?? false; }

    get pixelPitchRow() { return Z.one('#pixel-pitch-row'); }
    get pixelPitchSelect() { return Z.one<HTMLSelectElement>('#PixelPitch'); }
    get pixelPitch() { return Z.valueOf('#PixelPitch', '16mm'); }
    get pixelPitchInMM() { return parseFloat(this.pixelPitch.replace('Please Select', '').replace('mm', '')) || 16; }

    get horizontalPixelsPerModule() { return this.horizontalPixelsPerModuleForPitch(this.pixelPitch); }
    horizontalPixelsPerModuleForPitch(pixelPitch): number {
        if (pixelPitch == '5mm') return 64;
        if (pixelPitch == '6.67mm') return 48;
        if (pixelPitch == '8mm') return 40;
        if (pixelPitch == '10mm') return 32;
        if (pixelPitch == '13.33mm') return 24;
        return 20; // 16mm, default
    }

    get verticalPixelsPerModule() { return this.verticalPixelsPerModuleForPitch(this.pixelPitch); }
    verticalPixelsPerModuleForPitch(pixelPitch): number {
        return this.horizontalPixelsPerModuleForPitch(pixelPitch);
    }

    get horizontalPixels() { return this.horizontalPixelsForPitch(this.pixelPitch); }
    horizontalPixelsForPitch(pixelPitch): number {
        return this.horizontalPixelsPerModuleForPitch(pixelPitch) * app.signDesigner.selectionWidth;
    }
    get verticalPixels() { return this.verticalPixelsForPitch(this.pixelPitch); }
    verticalPixelsForPitch(pixelPitch): number {
        return this.verticalPixelsPerModuleForPitch(pixelPitch) * app.signDesigner.selectionHeight;
    }
    get totalPixels() { return this.totalPixelsForPitch(this.pixelPitch); }
    totalPixelsForPitch(pixelPitch): number {
        return this.horizontalPixelsForPitch(pixelPitch) * this.verticalPixelsForPitch(pixelPitch);
    }

    get minDistanceForTextVisibilityInM() {
        if (this.pixelPitch == '5mm') return 5;
        if (this.pixelPitch == '6.67mm') return 6;
        if (this.pixelPitch == '8mm') return 8;
        if (this.pixelPitch == '10mm') return 10;
        if (this.pixelPitch == '13.33mm') return 13;
        return 16; // 16mm, default
    }
    get minDistanceForImageVisibilityInM() {
        if (this.pixelPitch == '5mm') return 10;
        if (this.pixelPitch == '6.67mm') return 12;
        if (this.pixelPitch == '8mm') return 16;
        if (this.pixelPitch == '10mm') return 20;
        if (this.pixelPitch == '13.33mm') return 26;
        return 32; // 16mm, default
    }
    get minDistanceForVideoVisibilityInM() {
        if (this.pixelPitch == '5mm') return 15;
        if (this.pixelPitch == '6.67mm') return 20;
        if (this.pixelPitch == '8mm') return 24;
        if (this.pixelPitch == '10mm') return 30;
        if (this.pixelPitch == '13.33mm') return 39;
        return 48; // 16mm, default
    }
    get maxDistanceForTextInM() { return this.requestedSignHeightInMM * 0.05; }
    get maxDistanceForImageInM() { return this.requestedSignHeightInMM * 0.04; }
    get maxDistanceForVideoInM() { return this.requestedSignHeightInMM * 0.03; }

    get textBasedVisibility() {
        if (this.maxDistanceForImageInM < this.minDistanceForTextVisibilityInM) return 'not suitable';
        return `from ${this.minDistanceForTextVisibilityInM} metres to ${Math.round(this.maxDistanceForTextInM)} metres`;
    }
    get imageBasedVisibility() {
        if (this.maxDistanceForImageInM < this.minDistanceForImageVisibilityInM) return 'not suitable';
        return `from ${this.minDistanceForImageVisibilityInM} metres to ${Math.round(this.maxDistanceForImageInM)} metres`;
    }
    get videoBasedVisibility() {
        if (this.controlSystem != 'Synchronous') return 'not applicable';
        if (this.maxDistanceForVideoInM < this.minDistanceForVideoVisibilityInM) return 'not suitable';
        return `from ${this.minDistanceForVideoVisibilityInM} metres to ${Math.round(this.maxDistanceForVideoInM)} metres`;
    }

    get controlSystemRow() { return Z.one('#control-system-row'); }
    get controlSystemSelect(): HTMLSelectElement { return Z.one<HTMLSelectElement>('#ControlSystem'); }
    get controlSystem() {
        return Z.valueOf('#ControlSystem');
    }
    get controlSystemRowVisible() { return this.controlSystemRow.classList.contains('d-none'); }
    set controlSystemRowVisible(to: boolean) {
        if (to) this.controlSystemRow.classList.remove('d-none');
        else this.controlSystemRow.classList.add('d-none');
    }

    get softwareSelectRow() { return Z.one('#software-system-row'); }
    get softwareSystemSelect(): HTMLSelectElement { return Z.one<HTMLSelectElement>('#SoftwareSystem'); }
    get softwareSystem() {
        return Z.valueOf('#SoftwareSystem');
    }
    get softwareSelectRowVisible() { return this.softwareSelectRow.classList.contains('d-none'); }
    set softwareSelectRowVisible(to: boolean) {
        if (to) this.softwareSelectRow.classList.remove('d-none');
        else this.softwareSelectRow.classList.add('d-none');
    }

    get networkConnectionRow() { return Z.one('#network-connection-row'); }
    get networkConnectionSelect(): HTMLSelectElement { return Z.one<HTMLSelectElement>('#NetworkConnection'); }
    get networkConnection() {
        return Z.valueOf('#NetworkConnection');
    }
    get networkConnectionRowVisible() { return this.videoConnectionRow.classList.contains('d-none'); }
    set networkConnectionRowVisible(to: boolean) {
        if (to) this.networkConnectionRow.classList.remove('d-none');
        else this.networkConnectionRow.classList.add('d-none');
    }

    get videoConnectionRow() { return Z.one('#video-connection-row'); }
    get videoConnectionSelect(): HTMLSelectElement { return Z.one<HTMLSelectElement>('#SynchronousVideoConnectionType'); }
    get videoConnection() {
        return Z.valueOf('#SynchronousVideoConnectionType');
    }
    get videoConnectionRowVisible() { return this.videoConnectionRow.classList.contains('d-none'); }
    set videoConnectionRowVisible(to: boolean) {
        if (to) this.videoConnectionRow.classList.remove('d-none');
        else this.videoConnectionRow.classList.add('d-none');
    }

    get requestedSignWidthInMM() { return parseInt(Z.valueOf('#RequestedSignWidthInMM', '960')); }
    set requestedSignWidthInMM(to: number) { Z.setValue('#RequestedSignWidthInMM', to, false); }

    get requestedSignHeightInMM() { return parseInt(Z.valueOf('#RequestedSignHeightInMM', '960')); }
    set requestedSignHeightInMM(to: number) { Z.setValue('#RequestedSignHeightInMM', to, false); }

    updateGui() {
        window['Z'] = Z;

        Z.init(this.form, 'save-on-tab-close', el => {
            window.addEventListener('beforeunload', ev => {
                this.updateForm(false);
            });
        });

        Z.init('button[data-quote-pathway-action]', 'quote-pathway-action-buttons', btn => {
            btn.addEventListener('click', ev => {
                this.updateForm(false);
                this.quotePathwayAction(btn.dataset.quotePathwayAction, btn);

                Z.forFirst<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>(`section[data-quote-pathway-action="${btn.dataset.quotePathwayAction}"] .focus-on-load`, el => {
                    el.focus();
                    if ('select' in el) el.select();
                });
            });
        });

        /*
        // prompt user if construction type will support requested size
        Z.init('#ConstructionType', 'confirm-changing-construction-type', el => {
            el.addEventListener('change', ev => {
                let isDivisibleX = Math.round(this.requestedSignWidthInMM / 960) * 960 == this.requestedSignWidthInMM;
                let isDivisibleY = Math.round(this.requestedSignHeightInMM / 960) * 960 == this.requestedSignHeightInMM;
                let isDivisible = isDivisibleX && isDivisibleY;
                console.log(`divisible x? ${isDivisibleX}, divisible y? ${isDivisibleY}, divisible? ${isDivisible}`);
                let me = this;
                if (this.constructionType == 'Aluminium') {
                    if (!isDivisible) {
                        let adjustedX = Math.max(Math.round(this.requestedSignWidthInMM / 960), 1) * 960;
                        let adjustedY = Math.max(Math.round(this.requestedSignHeightInMM / 960), 1) * 960;
                        Z.confirm({
                            prompt: 'Aluminium Construction',
                            text: `Aluminium construction requires that sign sizes must be divisible by 960mm cabinets. By clicking 'confirm', your sign size will be adjusted to ${adjustedX}mm x ${adjustedY}mm. Click 'Cancel' to change back to steel construction.`,
                            onConfirm(ok) {
                                app.signDesigner.selectionWidth = adjustedX / 320;
                                app.signDesigner.selectionHeight = adjustedY / 320;
                                me.requestedSignWidthInMM = adjustedX;
                                me.requestedSignHeightInMM = adjustedY;
                            },
                            onDismiss() {
                                me.constructionTypeSelect.value = 'Steel';
                            }
                        });
                    }
                } else if (this.constructionType == 'Steel') {

                }
            });
        });

        // prompt user if pixel pitch changes control system
        Z.init(`#PixelPitch`, 'confirm-changing-pixel-pitch', el => {
            el.addEventListener('change', ev => {
                let me = this;
                if (this.controlSystem == 'Embedded') {
                    if (this.totalPixelsForPitch(this.pixelPitch) >= VideoRequiredPixelThreshold) {
                        Z.confirm({
                            prompt: 'Pixel Pitch',
                            text: `With the selected pixel pitch of ${this.pixelPitch}, the total pixel resolution will require a synchronous video control system. Please click 'Confirm' to keep this pixel pitch and change to a synchronous video control system; or 'Cancel' to keep the embedded display controller and change your pixel pitch.`,
                            onConfirm(ok) {
                                //me.controlSystemSelect.value = 'Video';
                                Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                                me.controlSystemSelect.classList.add('readonly');
                            },
                            onDismiss() {
                                //me.controlSystemSelect.value = 'Embedded';
                                Z.setValue(me.controlSystemSelect, 'Embedded', true);
                                let pitchOptions = Z.selectFrom<HTMLOptionElement>(me.pixelPitchSelect, 'option').map(e => e.value);
                                for (let i = 0; i < pitchOptions.length; i++) {
                                    if (me.totalPixelsForPitch(pitchOptions[i]) < VideoRequiredPixelThreshold) {
                                        //me.pixelPitchSelect.value = pitchOptions[i];
                                        Z.setValue(me.pixelPitchSelect, pitchOptions[i]);
                                        break;
                                    }
                                }
                                me.controlSystemSelect.classList.remove('readonly');
                            }
                        })
                    }
                }
            });
        });

        // Prompt user if software system changed to BYO but control system is embedded
        Z.init('#SoftwareSystem', 'confirm-changing-software-system', el => {
            el.addEventListener('change', ev => {
                let me = this;
                if (this.softwareSystem == 'BYOMediaPlayer') {
                    if (this.controlSystem == 'Embedded') {
                        Z.confirm({
                            prompt: `Software System`,
                            text: `BYO media player control is not available for embedded display controllers. Click 'Confirm' to change your control system to 'Synchronous Video Controller', or 'Cancel' to keep 'Remote CMS' software system.`,
                            onConfirm() {
                                Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                            },
                            onDismiss() {
                                Z.setValue(me.softwareSystemSelect, 'RemoteCMS', true);
                            }
                        });
                    }
                }
            });
        });

        // Prompt user if control system changed to embedded but software system is BYO
        Z.init('#ControlSystem', 'confirm-changing-control-system', el => {
            el.addEventListener('change', ev => {
                let me = this;
                if (this.controlSystem == 'Embedded') {
                    if (this.softwareSystem == 'BYOMediaPlayer') {
                        Z.confirm({
                            prompt: `Control System`,
                            text: `BYO media player control is not available for embedded display controllers. Click 'Confirm' to change your control system to 'Embedded' and your software system to 'Remote CMS', or 'Cancel' to keep 'Synchronous' control system.`,
                            onConfirm() {
                                Z.setValue(me.softwareSystemSelect, 'RemoteCMS', true);
                            },
                            onDismiss() {
                                Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                            }
                        });
                    }
                }
            });
        });

        Z.init('#RequestedSignWidthInMM, #RequestedSignHeightInMM', 'prompt-user-for-size', el => {
            el.addEventListener('change', ev => {
                let me = this;
                if (this.videoRequired) {
                    if (this.controlSystem == 'Embedded') {
                        Z.confirm({
                            prompt: `Pixel Resolution`,
                            text: `The selected sign size and pitch has a pixel resolution that requires a Synchronous Video Controller. To use embedded controller, reduce the sign size or increase the pixel pitch.`,
                            onConfirm() {
                                Z.setValue(me.controlSystem, 'Embedded', true);
                            },
                            onDismiss() {
                            }
                        });
                    }
                }
            });
        }); */

        Z.init<HTMLInputElement>('input, select, textarea', 'store-prior-value', el => {
            ['input', 'mousedown', 'mouseup', 'focus'].forEach(cb => {
                el.addEventListener(cb, ev => {
                    if (!el.dataset.priorValue || el.dataset.priorValue != el.value) {
                        el.dataset.priorValue = el.value;
                    }
                });
            });
        });

        Z.init(`[data-increment="#RequestedSignWidthInMM"]`, 'increment-sign-width', btn => {
            btn.addEventListener('click', ev => {
                console.log(`increment requested sign width (${this.requestedSignWidthInMM}, ${this.requestedSignWidthInMM / 320}): ${this.constructionType}`);
                if (this.constructionType == 'Aluminium') {
                    this.requestedSignWidthInMM += 960;
                    if (this.requestedSignWidthInMM >= UpperAxisLimit * 320) {
                        this.requestedSignWidthInMM = UpperAxisLimit * 320;
                    }
                    app.signDesigner.selectionWidth = this.requestedSignWidthInMM / 320;

                } else {

                    let panelOpts = AcceptablePanelSizes.panelOpts;

                    let moduleWidth = this.requestedSignWidthInMM / 320;
                    if (moduleWidth < panelOpts[0]) {
                        console.log(` -> default to panelOpts[0] = ${panelOpts[0]}`);
                        moduleWidth = panelOpts[0];
                    }
                    if (moduleWidth > panelOpts[panelOpts.length - 1]) {
                        console.log(` -> default to panelOpts[panelOpts.length:${panelOpts.length} - 1] = ${panelOpts[panelOpts.length - 1]}`);
                        moduleWidth = panelOpts[panelOpts.length - 1];
                    }
                    let moduleIndex = panelOpts.indexOf(moduleWidth) + 1;
                    console.log(` -> moduleIndex = panelOpts.indexOf(moduleWidth:${panelOpts.indexOf(moduleWidth)}) + 1 = ${panelOpts.indexOf(moduleWidth) + 1}`);
                    if (moduleIndex >= panelOpts.length) moduleIndex = panelOpts.length - 1;

                    this.requestedSignWidthInMM = panelOpts[moduleIndex] * 320;
                    app.signDesigner.selectionWidth = panelOpts[moduleIndex];
                }
                Z.trigger('#RequestedSignWidthInMM', 'change');
            });
        });
        Z.init(`[data-decrement="#RequestedSignWidthInMM"]`, 'decrement-sign-width', btn => {
            btn.addEventListener('click', ev => {
                console.log(`decrement requested sign width (${this.requestedSignWidthInMM}, ${this.requestedSignWidthInMM / 320}): ${this.constructionType}`);
                if (this.constructionType == 'Aluminium') {
                    this.requestedSignWidthInMM -= 960;
                    if (this.requestedSignWidthInMM < 960) {
                        this.requestedSignWidthInMM = 960;
                    }

                    app.signDesigner.selectionWidth = this.requestedSignWidthInMM / 320;

                } else {

                    let panelOpts = AcceptablePanelSizes.panelOpts;

                    let moduleWidth = this.requestedSignWidthInMM / 320;
                    if (moduleWidth < panelOpts[0]) {
                        console.log(` -> default to panelOpts[0] = ${panelOpts[0]}`);
                        moduleWidth = panelOpts[0];
                    }
                    if (moduleWidth > panelOpts[panelOpts.length - 1]) {
                        console.log(` -> default to panelOpts[panelOpts.length:${panelOpts.length} - 1] = ${panelOpts[panelOpts.length - 1]}`);
                        moduleWidth = panelOpts[panelOpts.length - 1];
                    }

                    let moduleIndex = panelOpts.indexOf(moduleWidth) - 1;
                    console.log(` -> moduleIndex = panelOpts.indexOf(moduleWidth:${panelOpts.indexOf(moduleWidth)}) - 1 = ${panelOpts.indexOf(moduleWidth) - 1} (${moduleIndex})`);
                    if (moduleIndex < 0) moduleIndex = 0;

                    this.requestedSignWidthInMM = panelOpts[moduleIndex] * 320;
                    app.signDesigner.selectionWidth = panelOpts[moduleIndex];
                }
                Z.trigger('#RequestedSignWidthInMM', 'change');
            });
        });
        Z.init(`[data-increment="#RequestedSignHeightInMM"]`, 'increment-sign-height', btn => {
            btn.addEventListener('click', ev => {
                console.log(`increment requested sign height (${this.requestedSignHeightInMM}, ${this.requestedSignHeightInMM / 320}): ${this.constructionType}`);
                if (this.constructionType == 'Aluminium') {
                    this.requestedSignHeightInMM += 960;
                    if (this.requestedSignHeightInMM >= UpperAxisLimit * 320) {
                        this.requestedSignHeightInMM = UpperAxisLimit * 320;
                    }

                    app.signDesigner.selectionHeight = this.requestedSignHeightInMM / 320;

                } else {

                    let panelOpts = AcceptablePanelSizes.panelOpts;

                    let moduleHeight = this.requestedSignHeightInMM / 320;
                    console.log(`module height ${moduleHeight} of [${panelOpts.join(', ')}] (${panelOpts.indexOf(moduleHeight)})`);
                    if (moduleHeight < panelOpts[0]) {
                        console.log(` -> default to panelOpts[0] = ${panelOpts[0]}`);
                        moduleHeight = panelOpts[0];
                    }
                    if (moduleHeight > panelOpts[panelOpts.length - 1]) {
                        console.log(` -> default to panelOpts[panelOpts.length:${panelOpts.length} - 1] = ${panelOpts[panelOpts.length - 1]}`);
                        moduleHeight = panelOpts[panelOpts.length - 1];
                    }

                    let moduleIndex = panelOpts.indexOf(moduleHeight) + 1;
                    if (moduleIndex >= panelOpts.length) moduleIndex = panelOpts.length - 1;
                    console.log(` -> moduleIndex = panelOpts.indexOf(moduleHeight:${panelOpts.indexOf(moduleHeight)}) + 1 = ${panelOpts.indexOf(moduleHeight) + 1} (${moduleIndex})`);

                    this.requestedSignHeightInMM = panelOpts[moduleIndex] * 320;
                    app.signDesigner.selectionHeight = panelOpts[moduleIndex];
                }
                Z.trigger('#RequestedSignHeightInMM', 'change');
            });
        });
        Z.init(`[data-decrement="#RequestedSignHeightInMM"]`, 'decrement-sign-height', btn => {
            btn.addEventListener('click', ev => {
                console.log(`decrement requested sign height (${this.requestedSignHeightInMM}, ${this.requestedSignHeightInMM / 320}): ${this.constructionType}`);
                if (this.constructionType == 'Aluminium') {
                    this.requestedSignHeightInMM -= 960;
                    if (this.requestedSignHeightInMM < 960) {
                        this.requestedSignHeightInMM = 960;
                    }

                    app.signDesigner.selectionHeight = this.requestedSignHeightInMM / 320;

                } else {

                    let panelOpts = AcceptablePanelSizes.panelOpts;

                    let moduleHeight = this.requestedSignHeightInMM / 320;
                    console.log(`module height ${moduleHeight} of [${panelOpts.join(', ')}] (${panelOpts.indexOf(moduleHeight)})`);
                    if (moduleHeight < panelOpts[0]) {
                        console.log(` -> default to panelOpts[0] = ${panelOpts[0]}`);
                        moduleHeight = panelOpts[0];
                    }
                    if (moduleHeight > panelOpts[panelOpts.length - 1]) {
                        console.log(` -> default to panelOpts[panelOpts.length:${panelOpts.length} - 1] = ${panelOpts[panelOpts.length - 1]}`);
                        moduleHeight = panelOpts[panelOpts.length - 1];
                    }

                    let moduleIndex = panelOpts.indexOf(moduleHeight) - 1;
                    if (moduleIndex < 0) moduleIndex = 0;

                    console.log(` -> moduleIndex = panelOpts.indexOf(moduleHeight:${panelOpts.indexOf(moduleHeight)}) - 1 = ${panelOpts.indexOf(moduleHeight) - 1}`);
                    this.requestedSignHeightInMM = panelOpts[moduleIndex] * 320;
                    app.signDesigner.selectionHeight = panelOpts[moduleIndex];
                }
                Z.trigger('#RequestedSignHeightInMM', 'change');
            });
        });

        Z.init('form#quote-designer-form input, select, textarea', 'form-inputs', el => {
            el.addEventListener('change', ev => this.updateForm(false));
        });

        Z.init('form#quote-designer-form .submit-quote-form-button', 'submit-form-quote-button', el => {
            el.addEventListener('click', ev => this.updateForm(true, false));
        });
    }

    get quoteId() {
        return this.form.dataset.quoteId;
    }

    /*get formData(): Record<string, any> {
        let formData = new FormData(this.form);
        let values: Record<string, any> = {};
        formData.forEach((value, key, form) => {
            values[key] = value;
        });
        return values;
    }*/

    get formData() {
        return new FormData(this.form);
    }
    get formDataAsRecord() {
        let record: Record<string, string> = {};
        let formData = this.formData;
        formData.forEach((val, key) => {
            record[key] = `${val}`;
        });
        return record;
    }

    lastData: Record<string, string> = this.formDataAsRecord;

    get videoRequired() { return this.totalPixels >= 130000; }

    get modulesDivisible() {
        if (this.constructionType == 'Steel') {
            let panelOpts = AcceptablePanelSizes.panelOpts;
            let acceptablePanelSizes = AcceptablePanelSizes.acceptablePanelGrid;

            let modulesW = Math.round(this.requestedSignWidthInMM / 320);
            let modulesH = Math.round(this.requestedSignHeightInMM / 320);
            if (panelOpts.indexOf(modulesW) === -1 || panelOpts.indexOf(modulesH) === -1) {
                return false;
            }
            if (acceptablePanelSizes[modulesW].indexOf(modulesH) !== -1) {
                return false;
            }
            if (acceptablePanelSizes[modulesH].indexOf(modulesW) !== -1) {
                return false;
            }

        } else if (this.constructionType == 'Aluminium') {
            if (Math.round(this.requestedSignWidthInMM / 960) * 960 != this.requestedSignWidthInMM) {
                return false;
            }
            if (Math.round(this.requestedSignHeightInMM / 960) * 960 != this.requestedSignHeightInMM) {
                return false;
            }
        }
        return true;
    }

    prevData: Record<string, any> = null;

    //get signUpForAccountCheckbox() { return Z.first<HTMLInputElement>('input#SignUpForAccount') }
    get signUpForAccountSelect() { return Z.first<HTMLSelectElement>('select#SignUpForAccount'); }
    //get signUpForAccount() { return this.signUpForAccountCheckbox?.checked ?? false; }
    get signUpForAccount() { return JSON.parse(this.signUpForAccountSelect.value); }
    set signUpForAccount(to: boolean) {
        if (this.signUpForAccountSelect) {
            //this.signUpForAccountCheckbox.checked = to;
            this.signUpForAccountSelect.value = to.toString();
            Z.trigger(this.signUpForAccountSelect, 'change');
        }
    }

    get signUpForMailingListRow() { return Z.first('#SignUpToMailingList-row'); }
    get signUpForMailingListCheckbox() { return Z.first<HTMLInputElement>('input#SignUpToMailingList'); }
    get signUpForMailingList() { return this.signUpForMailingListCheckbox?.checked ?? false; }
    set signUpForMailingList(to: boolean) {
        if (this.signUpForMailingListCheckbox) {
            this.signUpForMailingListCheckbox.checked = to;
            Z.trigger(this.signUpForMailingListCheckbox, 'change');
        } 
    }

    get userNameRow() { return Z.first('#UserName-row'); }
    get userPhoneNumberRow() { return Z.first('#UserPhoneNumber-row'); }
    get companyNameRow() { return Z.first('#CompanyName-row'); }

    get companyPostalAddressRow() { return Z.first('#CompanyPostalAddress-row'); }
    get companyDeliveryAddressRow() { return Z.first('#CompanyDeliveryAddress-row'); }
    get companyPhoneRow() { return Z.first('#CompanyPhone-row'); }

    checkReadonlyControls() {
        if (this.signUpForAccountSelect) {
            [
                this.companyPostalAddressRow,
                this.companyDeliveryAddressRow,
                this.companyPhoneRow,
                this.userNameRow,
                this.userPhoneNumberRow,
                this.companyNameRow,
                this.signUpForMailingListRow,
            ].forEach(el => {
                if (!el) return;
                if (this.signUpForAccount) {
                    el.classList.remove('d-none');
                } else {
                    el.classList.add('d-none');
                }
            });
        }

        if (app.signDesigner?.activeBackground) {
            // lock 'ConstructionType' if sign size is not aluminium divisible
            if (this.modulesDivisible) {
                this.constructionTypeSelect.classList.remove('readonly');
            } else {
                this.constructionTypeSelect.classList.add('readonly');
            }
        } else {
            // unlock 'ConstructionType'
            this.constructionTypeSelect.classList.remove('readonly');
        }

        // todo: make readonly
        if (this.videoRequired) {
            if (this.controlSystem == 'Synchronous') {
                this.controlSystemSelect.parentElement.classList.add('readonly');
            } else {
                this.controlSystemSelect.parentElement.classList.remove('readonly');
            }
        } else {
            this.controlSystemSelect.parentElement.classList.remove('readonly');
        }
        if (this.controlSystem == 'Embedded') {
            if (this.softwareSystem == 'RemoteCMS') {
                this.softwareSystemSelect.parentElement.classList.add('readonly');
            } else {
                this.softwareSystemSelect.parentElement.classList.remove('readonly');
            }
        } else {
            this.softwareSystemSelect.parentElement.classList.remove('readonly');
        }

        /*
            If Synchronous Video Controller – Video Capable is selected

            And Bring Your Own (BYO) Media Player with HDMI connection for Software system, then only the following is available

                Network Connection:
                -	“LAN Direct to screen, Ethernet or Wifi Access Point connection”
                -	“Rack mounted controller with ethernet connection and CAT5/6 data cable to screen (Max 100M)”

            Or RemoteCMS Software Control System for Software system, then only the following is available

                Network Connection:
                -	“LAN Direct to screen, Ethernet or Wifi Access Point connection”
                -	“4G mobile installed within screen, Bring Your Own (BYO) SIM card”
                -	“4G mobile installed within screen, With Telstra SIM card provided and managed”
                -	“Rack mounted controller with ethernet connection and CAT5/6 data cable to screen (Max 100M)”
        */

        let networkConnectionsAvailable = {
            'DirectEthernetOrWifiToScreen': true,
            'WifiOrLanToControllerIncCabling': true,
            'WifiOrLanToControllerBluetoothToScreen': true,
            'Mobile4GIncludingHosting': true,
            'Mobile4GWithByoSimCard': true,
        };

        if (this.softwareSystem == 'RemoteCMS') {
            this.networkConnectionRowVisible = true;
            Z.forEach(`option[data-rcms-label][data-byo-label]`, opt => opt.innerText = opt.dataset.rcmsLabel);
        } else {
            this.networkConnectionRowVisible = false;
            Z.forEach(`option[data-rcms-label][data-byo-label]`, opt => opt.innerText = opt.dataset.byoLabel);
        }

        if (this.controlSystem == 'Synchronous') {
            this.networkConnectionRowVisible = true;
            networkConnectionsAvailable.WifiOrLanToControllerBluetoothToScreen = false;

            if (this.softwareSystem == 'BYOMediaPlayer') {
                /*
                    Network Connection:
                    -	“LAN Direct to screen, Ethernet or Wifi Access Point connection”
                    -	“Rack mounted controller with ethernet connection and CAT5/6 data cable to screen (Max 100M)”
                */
                networkConnectionsAvailable.Mobile4GIncludingHosting = false;
                networkConnectionsAvailable.Mobile4GWithByoSimCard = false;
                this.videoConnectionRowVisible = false;

            } else if (this.softwareSystem == 'RemoteCMS') {
                /*
                    Network Connection:
                -	“LAN Direct to screen, Ethernet or Wifi Access Point connection”
                -	“4G mobile installed within screen, Bring Your Own (BYO) SIM card”
                -	“4G mobile installed within screen, With Telstra SIM card provided and managed”
                -	“Rack mounted controller with ethernet connection and CAT5/6 data cable to screen (Max 100M)”
                */
                this.videoConnectionRowVisible = false;

            }
        }

        Object.keys(networkConnectionsAvailable).forEach(key => {
            Z.forEachFrom<HTMLOptionElement>(this.networkConnectionSelect, `option[value="${key}"]`, o => o.disabled = networkConnectionsAvailable[key] == false);
        });
        if (Z.oneFrom<HTMLOptionElement>(this.networkConnectionSelect, `option[value="${this.networkConnectionSelect.value}"]`).disabled) {
            this.networkConnectionSelect.selectedIndex = 0;
        }
    }

    logUpdates: boolean = false;

    updateForm(andSubmit: boolean, diffOnly: boolean = true) {
        if (!this.prevData || !Object.keys(this.prevData).length) {
            this.prevData = this.formDataAsRecord;
        }

        let fd = this.formData;

        Z.forEach('.is-invalid', el => el.classList.remove('is-invalid'));
        fd.append(`PresetTemplateImage`, Z.first<HTMLImageElement>('#default-sign-bg-image-2').src);

        let attr: RequestInit = {
            method: 'post',
            body: fd,
        };

        let diff: Record<string, any> = {};
        //let prev: Record<string, any> = {};

        if (this.logUpdates) console.log(`Update:`);
        this.formData.forEach((value, key) => {
            if (Object.keys(this.lastData).indexOf(key) === -1 || this.lastData[key] != `${value}`) {
                this.prevData[key] = this.lastData[key] || '';
                diff[key] = `${value}`;
                if (this.logUpdates) console.log(`\t${key} => [${`${value}`.padEnd(10).substring(0, 10).trim()}]`);
            }

            this.lastData[key] = `${value}`;
        });

        let me = this;
        if ('ConstructionType' in diff) {
            // Prompt if cabinet size is invalid
            if (!this.modulesDivisible) {
                if (this.constructionType == 'Aluminium') {

                    let adjustedX = Math.max(Math.round(this.requestedSignWidthInMM / 960), 1) * 960;
                    let adjustedY = Math.max(Math.round(this.requestedSignHeightInMM / 960), 1) * 960;
                    Z.confirm({
                        prompt: 'Aluminium Construction',
                        text: `Aluminium construction requires that sign sizes must be divisible by 960mm cabinets. By clicking 'confirm', your sign size will be adjusted to ${adjustedX}mm x ${adjustedY}mm. Click 'Cancel' to change back to steel construction.`,
                        onConfirm(ok) {
                            app.signDesigner.selectionWidth = adjustedX / 320;
                            app.signDesigner.selectionHeight = adjustedY / 320;
                            me.requestedSignWidthInMM = adjustedX;
                            me.requestedSignHeightInMM = adjustedY;
                            me.checkReadonlyControls();
                        },
                        onDismiss() {
                            Z.setValue(me.constructionTypeSelect, 'Steel', true);
                            me.checkReadonlyControls();
                        }
                    });
                    this.checkReadonlyControls();
                    return;

                } else if (this.constructionType == 'Steel') {
                }
            }
        }

        if ('PixelPitch' in diff) {
            // Prompt if video control required
            if (this.videoRequired) {
                if (this.controlSystem == 'Embedded') {
                    Z.confirm({
                        prompt: 'Pixel Pitch',
                        text: `With the selected pixel pitch of ${this.pixelPitch}, the total pixel resolution will require a synchronous video control system. Please click 'Confirm' to keep this pixel pitch and change to a synchronous video control system; or 'Cancel' to keep the embedded display controller and change your pixel pitch.`,
                        onConfirm(ok) {
                            //me.controlSystemSelect.value = 'Video';
                            Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                            me.checkReadonlyControls();
                        },
                        onDismiss() {
                            //me.controlSystemSelect.value = 'Embedded';
                            Z.setValue(me.controlSystemSelect, 'Embedded', true);
                            let pitchOptions = Z.selectFrom<HTMLOptionElement>(me.pixelPitchSelect, 'option').map(e => e.value);
                            for (let i = 0; i < pitchOptions.length; i++) {
                                if (me.totalPixelsForPitch(pitchOptions[i]) < VideoRequiredPixelThreshold) {
                                    //me.pixelPitchSelect.value = pitchOptions[i];
                                    Z.setValue(me.pixelPitchSelect, pitchOptions[i]);
                                    me.checkReadonlyControls();
                                    break;
                                }
                            }
                        }
                    });
                    this.checkReadonlyControls();
                    return;
                }
            }
        }

        if ('RequestedSignWidthInMM' in diff || 'RequestedSignHeightInMM' in diff) {
            if (this.videoRequired) {
                if (this.controlSystem == 'Embedded') {
                    let reducedX = me.prevData.RequestedSignWidthInMM || this.requestedSignWidthInMM;
                    let reducedY = me.prevData.RequestedSignHeightInMM || this.requestedSignHeightInMM;
                    let willFit = false;
                    for (let i = 0; !willFit && i < 1024; i++) {
                        if ((i % 2) == 0) {
                            reducedX -= 960;
                        } else {
                            reducedY -= 960;
                        }
                        if (reducedX < 960) reducedX = 960;
                        if (reducedY < 960) reducedY = 960;

                        let modulesX = reducedX / 320;
                        let modulesY = reducedY / 320;
                        let hpix = this.horizontalPixelsPerModule * modulesX;
                        let ypix = this.verticalPixelsPerModule * modulesY;
                        let resolution = hpix * ypix;
                        willFit = resolution < VideoRequiredPixelThreshold;
                        console.log(`[${reducedX} x ${reducedY}] | ${this.horizontalPixelsPerModule} x ${this.verticalPixelsPerModule} | ${modulesX} x ${modulesY} (${hpix} x ${ypix}: ${resolution}) ${willFit}`);
                    }

                    Z.confirm({
                        prompt: 'Sign Resolution',
                        text: `With the selected pixel pitch of ${this.pixelPitch}, the total pixel resolution will require a synchronous video control system. Please click 'Confirm' to keep this pixel pitch and change to a synchronous video control system; or 'Cancel' to keep the embedded display controller and use the sign size ${reducedX}mm x ${reducedY}mm.`,
                        onConfirm(ok) {
                            Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                            me.checkReadonlyControls();
                        },
                        onDismiss() {
                            me.requestedSignWidthInMM = reducedX;
                            me.requestedSignHeightInMM = reducedY;
                            app.signDesigner.selectionWidth = reducedX / 320;
                            app.signDesigner.selectionHeight = reducedY / 320;
                            Z.setValue(me.controlSystemSelect, 'Embedded', true);
                            me.checkReadonlyControls();
                        }
                    });
                    this.checkReadonlyControls();
                    return;
                }
            }
        }

        if ('ControlSystem' in diff) {
            if (this.controlSystem == 'Embedded') {
                if (this.softwareSystem != 'RemoteCMS') {
                    Z.confirm({
                        prompt: `Control System`,
                        text: `BYO media player control is not available for embedded display controllers. Click 'Confirm' to change your control system to 'Embedded' and your software system to 'Remote CMS', or 'Cancel' to keep 'Synchronous' control system.`,
                        onConfirm() {
                            Z.setValue(me.softwareSystemSelect, 'RemoteCMS', true);
                            me.checkReadonlyControls();
                        },
                        onDismiss() {
                            Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                            me.checkReadonlyControls();
                        }
                    });
                    this.checkReadonlyControls();
                    return;
                }
            }
        }

        if ('SoftwareSystem' in diff) {
            if (this.softwareSystem == 'BYOMediaPlayer') {
                if (this.controlSystem == 'Embedded') {
                    Z.confirm({
                        prompt: `Software System`,
                        text: `BYO media player control is not available for embedded display controllers. Click 'Confirm' to change your control system to 'Synchronous Video Controller', or 'Cancel' to keep 'Remote CMS' software system.`,
                        onConfirm() {
                            Z.setValue(me.controlSystemSelect, 'Synchronous', true);
                            me.checkReadonlyControls();
                        },
                        onDismiss() {
                            Z.setValue(me.softwareSystemSelect, 'RemoteCMS', true);
                            me.checkReadonlyControls();
                        }
                    });
                    this.checkReadonlyControls();
                    return;
                }
            }
        }

        if ('NetworkConnection' in diff) {

        }

        if ('VideoConnection' in diff) {

        }

        this.checkReadonlyControls();

        app.signDesigner?.onChange();
        Z.setText(`[data-display="module-size-w"]`, app.signDesigner.selectionWidth);
        Z.setText(`[data-display="module-size-h"]`, app.signDesigner.selectionHeight);
        Z.setText(`[data-display="pixel-res-w"]`, this.horizontalPixels);
        Z.setText(`[data-display="pixel-res-h"]`, this.verticalPixels);
        Z.setText(`[data-display="pixel-res-total"]`, this.totalPixels + (this.videoRequired ? ' (video required)' : ''));

        if (diffOnly && !Object.keys(diff).length) return;

        if (andSubmit) {
            Z.spinUp('.submit-quote-form-button');
        }

        fetch(`/quote/update/${this.quoteId}?gui=${this.guiType}&uc=${new Date().getTime()}${andSubmit ? '&submit=true' : ''}`, attr)
            .then(resp => {
                if (resp.ok) {
                    resp.text().then(html => {
                        if (html.trim().startsWith('{')) {
                            let json = JSON.parse(html);
                            Z.fetcher.handleSuccessfulJsonResponse(json);
                        } else {
                            return;
                            let dom = Z.parseHtmlAsTemplate(html);
                            let scrollTop = this.appContainer.scrollTop;
                            let focusedElementId = Z.firstFrom(this.appContainer, ':focus[id]')?.id;

                            //Z.empty(this.appContainer);
                            //this.appContainer.appendChild(dom);
                            /*Z.forFirst('div.page-body', div => {
                                Z.empty(div);
                                div.appendChild(Z.oneFrom(dom, 'form'));
                            });*/

                            Z.forEach('section[data-quote-pathway-action]', panel => {
                                if (panel.dataset.quotePathwayAction == 'grid-tool') {
                                    return;
                                }

                                let replacement = Z.firstFrom(dom, `section[data-quote-pathway-action="${panel.dataset.quotePathwayAction}"]`);
                                if (replacement) {
                                    if (panel.classList.contains('active')) replacement.classList.add('active');
                                    panel.replaceWith(replacement);
                                    /*Z.empty(panel);
                                    replacement.childNodes.forEach(n => {
                                        panel.appendChild(n);
                                    }); */
                                }
                            });

                            Z.updateLayout();
                            app.signDesigner?.onChange();

                            this.appContainer.scrollTop = scrollTop;
                            if (focusedElementId) {
                                Z.forFirstFrom(this.appContainer, `#${focusedElementId}`, el => el.focus());
                            }
                        }
                    });
                } else {
                    resp.json().then(json => {
                        Z.fetcher.handleFailedJsonResponse(json);
                        Z.spinDown();

                        Z.forEach('.is-invalid', el => {
                            Z.forEach(`.quote-application-pathway section[data-quote-pathway-action]`, p => {
                                if (p.contains(el)) {
                                    p.classList.add('active');
                                } else {
                                    p.classList.remove('active');
                                }
                            });
                        });
                    });
                }
            }).catch(err => {
                console.log(err);
            });
    }

}